const BuildInfo = ({ commitHash }: { commitHash: string }) => {
    return commitHash ? (
        <label
            onClick={() => {
                window.location.reload()
            }}
        >
            Build: {commitHash.slice(0, 7)}
        </label>
    ) : (
        ''
    )
}
export default BuildInfo
